module.exports = "<p>\r\n  {{notFoundText}}\r\n</p>\r\n"